let timeout;
let asyncTimeout;

/**
 * Debounces the execution whatever is wrapped GLOBALLY (╯°□°）╯︵ ┻━┻ (MULTIPLE FUNCTIONS WILL PREVENT EACH OTHER FROM EXECUTING)
 * @param {function} func the debounced function
 * @param {Number} wait the debounce time
 */
const debounce = function (func, wait) {
  const later = () => {
    timeout = null;
    func.call();
  };
  clearTimeout(timeout);
  timeout = setTimeout(later, wait);
};

/**
 * Returns another function that is debounced with itself, not globally
 * @param {function} func the debounced function
 * @param {Number} wait the debounce time
 */
const debounceFunction = function (fn, wait) {
  let timeoutVariable = null;

  const debounce = function (func, wait) {
    const later = () => {
      timeoutVariable = null;
      func.call();
    };
    clearTimeout(timeoutVariable);
    timeoutVariable = setTimeout(later, wait);
  };

  return () => debounce(fn, wait);
};

/**
 * Debounces the resolution of a promise
 * @param {Promise} promiseFn the promise debounced
 * @param {Number} wait the debounce time
 * @returns a resolved promise
 */
const asyncDebounce = function (promiseFn, wait) {
  return new Promise((resolve) => {
    clearTimeout(asyncTimeout);
    asyncTimeout = setTimeout(() => {
      asyncTimeout = null;
      promiseFn().then((response) => {
        resolve(response);
      });
    }, wait);
  });
};

export default {
  debounce,
  debounceFunction,
  asyncDebounce,
};
